/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.1",
    versionName: "0.2.0-nightly.2025.10.1",
    versionChannel: "nightly",
    buildDate: "2025-10-01T00:09:51.477Z",
    commitHash: "f0aa5da08ff5f78eecb33b9e5e7ce90bea7abc3c",
};
